import React, { useState, useRef } from 'react';
import { regionalLevelSales, coastDistribution, unitsConsumption } from '../../../../services/regionalLevelSales';
import { usePermissions } from '../../../../context/PermissionContext';

const useRegionalLevelSales = () => {
  const [coastDistributionState, setCoastDistributionState] = useState([]);
  const [unitsConsumptionState, setUnitsConsumptionState] = useState([]);
  const [regionalLevelSalesState, setRegionalLevelSalesState] = useState([]);
  const [regionalLevelSalesSequence, setRegionalLevelSalesSequence] = useState([]);
  const [regionalLevelSalesLoaded, setRegionalLevelSalesLoaded] = useState(false);
  const [accessDenied,setAccessDenied] = useState(false);
  const [loadingState, setLoadingState] = useState({
    regionalLevelSalesState: false,
    coastDistributionState:false,
    unitsConsumptionState:false
  })
  const [level, setLevel] = useState('region');
  
  const sectionMap = {
  region: "region_section",
  state: "state_section",
  city: "city_section",
  postal: "pincode_section",
  };

  const debounceRef = useRef(null);
  const permission = usePermissions();

    const canShowTable =
    (permission?.data?.area_wise_insights?.view_format?.category_wise?.display &&
      permission?.data?.area_wise_insights?.view_format?.category_wise?.allowed) ||
    (permission?.data?.area_wise_insights?.view_format?.product_wise?.display &&
      permission?.data?.area_wise_insights?.view_format?.product_wise?.allowed);

  const combinedPermission = {
    display:
      permission?.data?.area_wise_insights?.view_format?.category_wise?.display ||
      permission?.data?.area_wise_insights?.view_format?.product_wise?.display,
    allowed:
      permission?.data?.area_wise_insights?.view_format?.category_wise?.allowed ||
      permission?.data?.area_wise_insights?.view_format?.product_wise?.allowed,
  };

  const selectedTabPermission =
    permission?.data?.area_wise_insights?.[sectionMap[level]] || {};

  const tablePermission =
    permission?.data?.area_wise_insights?.table_section?.table_view || {};

  const combinedTablePermission = {
    display: selectedTabPermission.display && tablePermission.display,
    allowed: selectedTabPermission.allowed && tablePermission.allowed,
  };

  const getCoastDistribution = async ({ formattedEnd, formattedStart, level, selectedIds = [] }) => {
    setLoadingState((prev)=>({
      ...prev,
      coastDistributionState:true
    }))
    try {
      let response = await coastDistribution({ formattedEnd, formattedStart, level, selectedIds });
      if (response && response.success && response.data) {
        setCoastDistributionState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error('Failed coast distribution API called :',error)
      setUnitsConsumptionState([]);
    }finally{
      setLoadingState((prev)=>({
        ...prev,
        coastDistributionState:false
      }))
    }
  }

  const getUnitsConsumption = async ({ formattedEnd, formattedStart, level, selectedIds = [] }) => {
    setLoadingState((prev)=>({
      ...prev,
      unitsConsumptionState:true
    }))
    try {
      let response = await unitsConsumption({ formattedEnd, formattedStart, level, selectedIds });
      if (response && response.success && response.data) {
        setUnitsConsumptionState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error('Failed unit cosumption API calling :',error)
      setUnitsConsumptionState([]);
      if (error.status === 403){
        setAccessDenied(true)
      }
    }finally{
      setLoadingState((prev)=>({
        ...prev,
        unitsConsumptionState:false
      }))
    }
  }

  const getRegionalLevelSales = async ({ formattedEnd, formattedStart, level, selectedIds = [] }) => {
    setLoadingState((prev) => ({
      ...prev,
      regionalLevelSalesState: true
    }))
    setRegionalLevelSalesLoaded(false)
    try {
      let response = await regionalLevelSales({ formattedEnd, formattedStart, level, selectedIds });
      if (response && response.success && response.data) {
        setRegionalLevelSalesState(response.data);
        setRegionalLevelSalesSequence(response?.sequence);
      } else {
        setRegionalLevelSalesState([]);
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error("Error fetching time regional lavel sales:", error);
      if (error.status === 403){
        setAccessDenied(true)
      }
      setUnitsConsumptionState([]);
    } finally {
      setLoadingState((prev) => ({
        ...prev,
        regionalLevelSalesState: false
      }))
      setRegionalLevelSalesLoaded(true); 
    }
  }

  return {
    loadingState,
    coastDistributionState,
    unitsConsumptionState,
    regionalLevelSalesState,
    getRegionalLevelSales,
    getUnitsConsumption,
    sectionMap,
    getCoastDistribution, regionalLevelSalesSequence, regionalLevelSalesLoaded , canShowTable, combinedPermission, combinedTablePermission,tablePermission, level, setLevel,accessDenied
  };
};

export default useRegionalLevelSales;
